import { gql } from 'apollo-angular';
import {
  GetWidgetDataForReportQuery,
  GetWidgetDataForReportQueryVariables,
  GetWidgetDataQuery,
  GetWidgetDataQueryVariables,
} from 'gql/graphql';

export const createDashboardMutation = gql`
  mutation CreateDashboard($name: String!) {
    createDashboard(name: $name) {
      id
      name
      pinned
      refreshRate
      widgets {
        id
        type
        row
        col
        rowSpan
        colSpan
        metricTypeId
        propertyId
        groupId
        deviceIds
        title
        targetMin
        targetMax
        min
        max
        yAxis
        display
        categoryId
        criteria
        propertyIds
        groupIds
        timeFrame
        timeFrameDate
        deviceId
        contractId
        tariffId
        columns
        conversionFactor
        visualization
        targets
        customText
        thresholds
        metricIds
        constant
        otherMetricId
        operation
      }
    }
  }
`;
export const updateDashboardMutation = gql`
  mutation UpdateDashboard($id: ID!, $name: String!) {
    updateDashboard(id: $id, name: $name) {
      id
      name
      pinned
      refreshRate
      widgets {
        id
        type
        row
        col
        rowSpan
        colSpan
        metricTypeId
        propertyId
        groupId
        deviceIds
        title
        targetMin
        targetMax
        min
        max
        yAxis
        display
        categoryId
        criteria
        propertyIds
        groupIds
        timeFrame
        timeFrameDate
        deviceId
        contractId
        tariffId
        columns
        conversionFactor
        visualization
        targets
        customText
        thresholds
        metricIds
        constant
        otherMetricId
        operation
      }
    }
  }
`;

export const duplicateDashboardMutation = gql`
  mutation DuplicateDashboard($id: ID!, $name: String!) {
    duplicateDashboard(id: $id, name: $name) {
      id
      name
      pinned
      refreshRate
      widgets {
        id
        type
        row
        col
        rowSpan
        colSpan
        metricTypeId
        propertyId
        groupId
        deviceIds
        title
        targetMin
        targetMax
        min
        max
        yAxis
        display
        categoryId
        criteria
        propertyIds
        groupIds
        timeFrame
        timeFrameDate
        deviceId
        contractId
        tariffId
        columns
        conversionFactor
        visualization
        targets
        customText
        thresholds
        metricIds
        constant
        otherMetricId
        operation
      }
    }
  }
  `;

export const getDashboardsQuery = gql`
  query GetDashboards {
    getDashboards {
      id
      name
      pinned
      refreshRate
      widgets {
        id
        type
        row
        col
        rowSpan
        colSpan
        metricTypeId
        propertyId
        groupId
        deviceIds
        title
        targetMin
        targetMax
        min
        max
        yAxis
        display
        categoryId
        criteria
        propertyIds
        groupIds
        timeFrame
        timeFrameDate
        deviceId
        contractId
        tariffId
        columns
        conversionFactor
        visualization
        targets
        customText
        thresholds
        metricIds
        constant
        otherMetricId
        operation
      }
    }
  }
`;

export const createWidgetMutation = gql`
  mutation CreateWidget(
    $dashboardId: ID!
    $isDuplication: Boolean
    $type: String!
    $row: Int!
    $col: Int!
    $rowSpan: Int!
    $colSpan: Int!
    $metricTypeId: ID
    $propertyId: ID
    $groupId: ID
    $categoryId: ID
    $display: String!
    $yAxis: String
    $min: Float
    $max: Float
    $targetMin: Float
    $targetMax: Float
    $title: String!
    $deviceIds: [ID!]
    $criteria: String
    $propertyIds: [ID!]
    $groupIds: [ID!]
    $timeFrame: String
    $timeFrameDate: AWSDateTime
    $deviceId: ID
    $contractId: ID
    $tariffId: ID
    $columns: [String!]
    $conversionFactor: Float
    $visualization: String
    $targets: [Float!]
    $customText: String
    $thresholds: [String!]
    $metricIds: [ID!]
    $constant: Float
    $otherMetricId: ID
    $operation: String
  ) {
    createWidget(
      dashboardId: $dashboardId
      isDuplication: $isDuplication
      type: $type
      row: $row
      col: $col
      rowSpan: $rowSpan
      colSpan: $colSpan
      metricTypeId: $metricTypeId
      propertyId: $propertyId
      groupId: $groupId
      categoryId: $categoryId
      display: $display
      yAxis: $yAxis
      min: $min
      max: $max
      targetMin: $targetMin
      targetMax: $targetMax
      title: $title
      deviceIds: $deviceIds
      criteria: $criteria
      propertyIds: $propertyIds
      groupIds: $groupIds
      timeFrame: $timeFrame
      timeFrameDate: $timeFrameDate
      deviceId: $deviceId
      contractId: $contractId
      tariffId: $tariffId
      columns: $columns
      conversionFactor: $conversionFactor
      visualization: $visualization
      targets: $targets
      customText: $customText
      thresholds: $thresholds
      metricIds: $metricIds
      constant: $constant
      otherMetricId: $otherMetricId
      operation: $operation
    ) {
      id
      type
      row
      col
      rowSpan
      colSpan
      metricTypeId
      propertyId
      groupId
      deviceIds
      title
      targetMin
      targetMax
      min
      max
      yAxis
      display
      categoryId
      criteria
      propertyIds
      groupIds
      timeFrame
      timeFrameDate
      deviceId
      contractId
      tariffId
      columns
      conversionFactor
      visualization
      targets
      customText
      thresholds
      metricIds
      constant
      otherMetricId
      operation
    }
  }
`;

export const getWidgetMetricTypesQuery = gql`
  query GetWidgetMetricTypes(
    $categoryId: ID
    $assets: AssetListInput
    $widgetType: String
    $entityId: ID
    $entityIds: [ID!]
  ) {
    getWidgetMetricTypes(
      categoryId: $categoryId
      assets: $assets
      widgetType: $widgetType
      entityId: $entityId
      entityIds: $entityIds
    ) {
      id
      name
    }
  }
`;

export const updateWidgetsPositionMutation = gql`
  mutation UpdateWidgetsPosition(
    $dashboardId: ID!
    $widgetPositions: [WidgetPosition!]!
  ) {
    updateWidgetsPosition(
      dashboardId: $dashboardId
      widgetPositions: $widgetPositions
    ) {
      id
      name
      pinned
      refreshRate
      widgets {
        id
        type
        row
        col
        rowSpan
        colSpan
        metricTypeId
        propertyId
        groupId
        deviceIds
        title
        targetMin
        targetMax
        min
        max
        yAxis
        display
        categoryId
        criteria
        propertyIds
        groupIds
        timeFrame
        timeFrameDate
        deviceId
        contractId
        tariffId
        columns
        conversionFactor
        visualization
        targets
        customText
        thresholds
        metricIds
        constant
        otherMetricId
        operation
      }
    }
  }
`;

export const deleteWidgetMutation = gql`
  mutation DeleteWidget($dashboardId: ID!, $widgetId: ID!) {
    deleteWidget(dashboardId: $dashboardId, widgetId: $widgetId) {
      id
      name
      refreshRate
      pinned
      widgets {
        id
        type
        row
        col
        rowSpan
        colSpan
        metricTypeId
        propertyId
        groupId
        deviceIds
        title
        targetMin
        targetMax
        min
        max
        yAxis
        display
        categoryId
        criteria
        propertyIds
        groupIds
        timeFrame
        timeFrameDate
        deviceId
        contractId
        tariffId
        columns
        conversionFactor
        visualization
        targets
        customText
        thresholds
        metricIds
        constant
        otherMetricId
        operation
      }
    }
  }
`;

export const updateWidgetMutation = gql`
  mutation UpdateWidget(
    $id: ID!
    $dashboardId: ID!
    $type: String!
    $metricTypeId: ID
    $propertyId: ID
    $groupId: ID
    $categoryId: ID
    $display: String!
    $yAxis: String
    $min: Float
    $max: Float
    $targetMin: Float
    $targetMax: Float
    $title: String!
    $deviceIds: [ID!]
    $criteria: String
    $propertyIds: [ID!]
    $groupIds: [ID!]
    $timeFrame: String
    $timeFrameDate: AWSDateTime
    $deviceId: ID
    $contractId: ID
    $tariffId: ID
    $columns: [String!]
    $conversionFactor: Float
    $visualization: String
    $targets: [Float!]
    $customText: String
    $thresholds: [String!]
    $metricIds: [ID!]
    $constant: Float
    $otherMetricId: ID
    $operation: String
  ) {
    updateWidget(
      id: $id
      dashboardId: $dashboardId
      type: $type
      metricTypeId: $metricTypeId
      propertyId: $propertyId
      groupId: $groupId
      categoryId: $categoryId
      display: $display
      yAxis: $yAxis
      min: $min
      max: $max
      targetMin: $targetMin
      targetMax: $targetMax
      title: $title
      deviceIds: $deviceIds
      criteria: $criteria
      propertyIds: $propertyIds
      groupIds: $groupIds
      timeFrame: $timeFrame
      timeFrameDate: $timeFrameDate
      deviceId: $deviceId
      contractId: $contractId
      tariffId: $tariffId
      columns: $columns
      conversionFactor: $conversionFactor
      visualization: $visualization
      targets: $targets
      customText: $customText
      thresholds: $thresholds
      metricIds: $metricIds
      constant: $constant
      otherMetricId: $otherMetricId
      operation: $operation
    ) {
      id
      type
      row
      col
      rowSpan
      colSpan
      metricTypeId
      propertyId
      groupId
      deviceIds
      title
      targetMin
      targetMax
      min
      max
      yAxis
      display
      categoryId
      criteria
      propertyIds
      groupIds
      timeFrame
      timeFrameDate
      deviceId
      contractId
      tariffId
      columns
      conversionFactor
      visualization
      targets
      customText
      thresholds
      metricIds
      constant
      otherMetricId
      operation
    }
  }
`;

export const getWidgetDataQuery = gql<
  GetWidgetDataQuery,
  GetWidgetDataQueryVariables
>`
  query GetWidgetData($dashboardId: ID!, $widgetId: ID!) {
    getWidgetData(dashboardId: $dashboardId, widgetId: $widgetId) {
      __typename
      ... on ChartData {
        widgetId
        dashboardId
        label {
          text
          unit
        }
        series {
          name
          values {
            x
            y
          }
        }
      }
      ... on GaugeData {
        widgetId
        dashboardId
        value
        metric
      }
      ... on TableData {
        widgetId
        dashboardId
        items
        columns {
          label
          type
        }
      }
      ... on MaxMinData {
        widgetId
        dashboardId
        min
        max
        avg
        propertyOrGroup
        device
      }
      ... on WaterGasData {
        widgetId
        dashboardId
        value
        icon
        resolution
        propertyOrGroup
      }
      ... on TariffData {
        widgetId
        dashboardId
        cost
        name
        type
        tag
        devices
        usage
      }
      ... on ContractData {
        widgetId
        dashboardId
        name
        type
        tag
        devices
        tariffs {
          name
          cost
          usage
        }
        totalCost
      }
      ... on NumberAndListData {
        list
        value
        dashboardId
        widgetId
      }
      ... on ListWithTargetData {
        itemsWithTarget {
          name
          target
          value
        }
        unit
        dashboardId
        widgetId
      }
      ... on MapData {
        coordinates {
          lat
          lng
          label
          id
        }
        dashboardId
        widgetId
      }
      ... on KPIData {
        dashboardId
        widgetId
        kpi
      }
    }
  }
`;

export const getWidgetDataForReportQuery = gql<
  GetWidgetDataForReportQuery,
  GetWidgetDataForReportQueryVariables
>`
  query GetWidgetDataForReport(
    $reportId: ID!
    $widgetId: ID!
    $properties: [ID!]
    $fromDate: AWSDateTime
    $toDate: AWSDateTime
  ) {
    getWidgetDataForReport(
      reportId: $reportId
      widgetId: $widgetId
      properties: $properties
      fromDate: $fromDate
      toDate: $toDate
    ) {
      __typename
      ... on ChartData {
        label {
          text
          unit
        }
        widgetId
        dashboardId
        series {
          name
          values {
            x
            y
          }
        }
      }
      ... on GaugeData {
        widgetId
        dashboardId
        value
        metric
      }
      ... on TableData {
        widgetId
        dashboardId
        items
        columns {
          label
          type
        }
      }
      ... on MaxMinData {
        widgetId
        dashboardId
        min
        max
        avg
        propertyOrGroup
        device
      }
      ... on WaterGasData {
        widgetId
        dashboardId
        value
        icon
        resolution
        propertyOrGroup
      }
      ... on TariffData {
        widgetId
        dashboardId
        cost
        name
        type
        tag
        devices
        usage
      }
      ... on ContractData {
        widgetId
        dashboardId
        name
        type
        tag
        devices
        tariffs {
          name
          cost
          usage
        }
        totalCost
      }
      ... on NumberAndListData {
        list
        value
        dashboardId
        widgetId
      }
      ... on ListWithTargetData {
        itemsWithTarget {
          name
          target
          value
        }
        unit
        dashboardId
        widgetId
      }
      ... on MapData {
        coordinates {
          lat
          lng
          label
          id
        }
        dashboardId
        widgetId
      }
      ... on KPIData {
        dashboardId
        widgetId
        kpi
      }
    }
  }
`;

export const updateDashboardRefreshRateMutation = gql`
  mutation UpdateDashboardRefreshRate($dashboardId: ID!, $refreshRate: Int!) {
    updateDashboardRefreshRate(
      dashboardId: $dashboardId
      refreshRate: $refreshRate
    ) {
      id
      refreshRate
    }
  }
`;

export const pinDashboard = gql`
  mutation PinDashboard($dashboardId: ID!, $pinned: Boolean!) {
    pinDashboard(dashboardId: $dashboardId, pinned: $pinned)
  }
`;

export const deleteDashboard = gql`
  mutation DeleteDashboard($dashboardId: ID!) {
    deleteDashboard(dashboardId: $dashboardId)
  }
`;

export const savePdfReport = gql`
  mutation SavePdfReport(
    $name: String!
    $createdAt: AWSDateTime!
    $userId: ID!
    $content: String!
  ) {
    savePdfReport(
      name: $name
      createdAt: $createdAt
      userId: $userId
      content: $content
    )
  }
`;
